import { Component, Input } from '@angular/core';
import { labelMapper } from '../../e-met/services/utility-functions';

@Component({
  selector: 'app-recursive-comp',
  templateUrl: './recursive-comp.component.html',
  styleUrls: ['./recursive-comp.component.scss']
})
export class RecursiveCompComponent {
  @Input() recursiveList: any;
  @Input() ignoredKeys: string[] = [];
  @Input() documentType: string;
  constructor() { }

  mapKey(key: string): string {
    // return labelMapperEnfia(key);
    return labelMapper(key, this.documentType);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  isObject(value: any): boolean {
    return !(typeof(value) === 'string' || typeof(value) === 'number' || value === null);
  }

  logItem(item: any) {
    console.log(item);
  }

}
